import { UserEvent } from './user-event.model';
import { Coordinates } from '../coordinates.model';

export class DeclarationPositionEvent extends UserEvent {
  public static NAME = 'POSITION_EVENT';

  constructor(
    public idVacation: string,
    coordinates?: Coordinates
  ) {
    super(DeclarationPositionEvent.NAME, undefined, coordinates);
  }

  public static hydrate(obj: DeclarationPositionEvent): DeclarationPositionEvent {
    return new DeclarationPositionEvent(obj.idVacation, obj.coordinates);
  }
}
